<div class="my-3 p-3 new-series-container">
  <div class="d-flex justify-content-between">
    <div class="text-primary font-weight-bold">
      {{ 'DATA_STUDIO.DATA_ANALYSIS.ADD_NEW' | translate }}
    </div>
    <lib-button
      id="new-series-close-button"
      [size]="'custom'"
      [width]="30"
      [color]="'primary-link'"
      [faIcon]="'far fa-times'"
      (buttonClicked)="close()" >
    </lib-button>
  </div>
  <div class="mb-3 d-flex" [ngClass]="{'flex-wrap': expanded}">

    <app-element-selector
      [items]="parkElements"
      [withTimer]="true"
      [labels]="{
        title: 'PARKS_TITLE',
        all: 'ALL_PARKS',
        placeholder: 'SEARCH_FOR_ASSETS',
        noMatches: 'NO_MATCHING_SITES',
        loading: 'LOADING_PARKS'
      }"
      [loadingData]="loadingDeviceData"
      (itemSelect)="onParkSelect($event)"
      (allItemsSelect)="onAllParksSelect($event)"
    ></app-element-selector>

    <app-element-selector
      [ngClass]="{'devices-container': expanded}"
      [items]="filteredDevices"
      [filterOptions]="deviceTypeList"
      [withBlocks]="true"
      [withExpand]="true"
      [expanded]="expanded"
      [labels]="{
        title: 'DEVICES_TITLE',
        all: 'ALL_DEVICES',
        placeholder: 'SEARCH_FOR_DEVICES',
        noMatches: 'NO_MATCHING_DEVICES',
        loading: 'LOADING_DEVICES'
      }"
      [loadingData]="loadingDeviceData"
      (itemSelect)="onTurbineSelect($event)"
      (allItemsSelect)="onAllTurbinesSelect($event)"
      (filterChanged)="filterByDeviceType()"
      (expandChanged)="toggleExpand()"
    ></app-element-selector>

    <app-element-selector
      [ngClass]="{'signals-container': expanded}"
      [items]="signalElements"
      [filterOptions]="filteredTypesList"
      [withToggle]="true"
      [expanded]="expanded"
      [labels]="{
        title: 'SIGNALS_TITLE',
        all: 'ALL_SIGNALS',
        placeholder: 'SEARCH_FOR_SIGNALS',
        noMatches: 'NO_MATCHING_SIGNALS'
      }"
      [loadingData]="loadingDeviceData"
      (toggleChanged)="pinToggle()"
      (itemSelect)="onSignalSelect($event)"
      (allItemsSelect)="onAllSignalsSelect($event)"
      (filterChanged)="filterBySignalType()"
    ></app-element-selector>

  </div>
  <div class="d-flex justify-content-between">
    <div class="d-flex justify-content-start align-items-center font-size-small">
      @if (series?.length) {
        <span>
          <span class="font-weight-bold">{{series.length}}</span> {{ 'DATA_STUDIO.DATA_ANALYSIS.NEW_SELECTED' | translate }}
        </span>
      }
    </div>
    <div class="d-flex justify-content-end">
      <div class="pl-3 pr-2">
        <lib-button
          id="data-analysis-cancel-button"
          [color]="'secondary'"
          [label]="'BUTTONS.CANCEL' |translate"
          (buttonClicked)="close()" >
        </lib-button>
      </div>
      <div class="pr-3">
        <lib-button
          id="data-analysis-save-button"
          [label]="'BUTTONS.ADD' |translate"
          [disabled]="!series?.length || series?.length > MAX_SERIES_TO_ADD"
          (buttonClicked)="addNewSeries()" >
        </lib-button>
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-end mt-1 mt-3">
    @if (series?.length > MAX_SERIES_TO_ADD) {
      <small class="text-red">{{ 'DATA_STUDIO.DATA_ANALYSIS.MAX_SERIES_TO_ADD' | translate }} : {{ MAX_SERIES_TO_ADD }}</small>
    }
  </div>
</div>